<template>
  <el-col :xs="column||8" :sm="column||8">
    <div v-if="obj">
      <div class="state-block" :class="{'offline':obj.time<now_time-60*60}">
        <div class="tips">{{ tag }}</div>
        <div class="value" v-if="tag!=='土壤湿度' && tag!=='空气湿度'">{{obj.value}} {{obj.unit}}</div>
        <div class="value" v-if="tag==='土壤湿度' || tag==='空气湿度'"><el-progress :text-inside="true" :stroke-width="22" :percentage="obj.value" :format="progress_RH"></el-progress></div>
        <div class="offline-block">
          <div class="offline-block-txt1">{{obj.value}} {{obj.unit}}</div>
          <div class="offline-block-txt2">{{$moment(now_time*1000).format('YYYY-MM-DD')=== $moment(obj.time*1000).format('YYYY-MM-DD')?$moment(obj.time*1000).format('HH:mm'):$moment(obj.time*1000).format('YYYY-MM-DD HH:mm')}}</div>
        </div>
      </div>
    </div>
    <div v-if="!obj && allshow">
      <div class="state-block offline">
        <div class="tips">{{ tag }}</div>
        <div class="offline-block">
          <div class="offline-block-txt1">--</div>
        </div>
      </div>
    </div>
  </el-col>

</template>

<script>
export default {
  name: 'StateBlock',
  props: {
    column:Number,
    obj: Object,
    allshow: Boolean,
    now_time: Number,
    tag: String
  },
  methods: {
    progress_RH(percentage) {
      return `${percentage} %`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.state-block{
  position: relative;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding:0 10px;
  min-height: 68px;
  border-radius: 10px;
  background: #2c3e50;
  color: #fff;
  .tips{
    color: #ccc;
    padding: 5px 0;
    font-size: 12px;
  }
  .value{
    white-space: nowrap;
    text-align: center;
    line-height: 22px;
  }
  .offline-block{
    display: none;
  }


  &.offline{
    background: #717171;
    .value{
      display: none;
    }
    .offline-block{
      display: block;
      .offline-block-txt1{
        text-align: center;
        padding-top: 1px;
        font-size: 12px;

      }
      .offline-block-txt2{
        margin: 0 -10px;
        padding-top: 4px;
        text-align: center;
        font-size: 10px;
        color: #ccc;
        white-space: nowrap;

      }
    }
  }
}

</style>
